import React from 'react';

class FinishedTypingTextBox extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);

    this.state = {
      SearchQuery: props.defaultValue,
      LastSearchQuery: props.defaultValue,
      LastKeyPress: 0
    };
  }

  checkChange () {
    if (!Date.now) {
      Date.now = function () { return new Date().getTime() };
    }

    if ((Date.now() - this.props.delay) > this.state.LastKeyPress) {
      if (this.state.SearchQuery !== this.state.LastSearchQuery) {
        const changeData = {
          type: 'change',
          target: {
            name: this.props.name,
            value: this.state.SearchQuery
          }
        };

        this.setState({
          LastSearchQuery: this.state.SearchQuery
        });

        this.props.onChange(changeData);
      }
    }
  }

  handleOnFocus (event) {
    this.timer = window.setInterval(() => {
      this.checkChange();
    }, 100);

    this.props.onFocus(event);
  }

  handleOnBlur (event) {
    clearInterval(this.timer);
    this.props.onBlur(event);
  }

  componentWillUnmount () {
    clearInterval(this.timer);
  }

  handleOnChange (event) {
    let newSearchQuery = event.target.value;

    if (!Date.now) {
      Date.now = function () { return new Date().getTime() };
    }

    this.setState({
      SearchQuery: newSearchQuery,
      LastKeyPress: Date.now()
    });

    if (this.props.currentValue) {
      this.props.currentValue(event);
    }
  }

  render () {
    // Props that are omitted from being passed to the textbox
    const propsToOmit = ['onChange', 'onBlur', 'onFocus', 'delay', 'currentValue', 'inputRef'];
    let spreadProps = {};

    Object.keys(this.props).forEach((value) => {
      if (propsToOmit.indexOf(value) === -1) {
        spreadProps[value] = this.props[value];
      }
    });

    return (
      <input type='text' ref={this.props.inputRef} onFocus={this.handleOnFocus} onBlur={this.handleOnBlur} onChange={this.handleOnChange} {...spreadProps} />
    );
  }
}

FinishedTypingTextBox.propTypes = {
  onChange: React.PropTypes.func,
  onFocus: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  currentValue: React.PropTypes.func,
  defaultValue: React.PropTypes.string,
  name: React.PropTypes.string.isRequired,
  delay: React.PropTypes.number // How Often the compare is run in MS
};

FinishedTypingTextBox.defaultProps = {
  onFocus: () => {},
  onBlur: () => {},
  delay: 500,
};

export default FinishedTypingTextBox;



// WEBPACK FOOTER //
// ./src/components/Form/FinishedTyping.js